import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
    color: string;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other} variant='h3' textAlign={'center'}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        padding: `0 !important`,
                        backgroundColor: 'transparent !important',
                        color: `${(theme) => theme.palette.grey[500]} !important`,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

const App: React.FC<{ open: boolean, close: () => void, msg: string, title: string, color: string }> = (props) => {

    return (
        <BootstrapDialog
            onClose={props.close}
            aria-labelledby="customized-dialog-title"
            open={props.open}
            sx={{
                "& Button": {
                    padding: '0px',
                    background: 'transparent ',
                    color: '#408697 ',
                    borderColor: '#bdbdbd ',
                    marginLeft: '10px',
                    fontSize: '12px',

                },
            }}
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={props.close} color={props.color}>
                {props.title}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Typography variant="h5" gutterBottom>
                    {props.msg}
                </Typography>
            </DialogContent>
            <DialogActions>
                <OkButton autoFocus onClick={props.close} sx={{ color: '#fff !important' }}>
                    Ok
                </OkButton>
            </DialogActions>
        </BootstrapDialog >
    );
}
const OkButton = styled(Button)`
    width: 100%;
    background: #408697 !important;
    font-family: sans-serif !important;
    
`
export default App